module.exports = __webpack_public_path__ + "assets/81d557776063fb3018b6049295d3959b.svg";